import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getYear',
  standalone: true
})
export class GetYearPipe implements PipeTransform {
  public transform(value: Date | string | undefined): number {
    if (!value) {
      return 0;
    }

    value = new Date(value);

    return value.getFullYear();
  }
}
